<template>
  <v-card
    :id="`config-card-${id}`"
    :prepend-icon="icon"
    :title="title"
    color="grey-lighten-4"
    elevation="0"
    class="config-card d-flex flex-column py-4"
    min-height="450"
    border
  >
    <template #prepend>
      <v-icon color="cyan-dark"></v-icon>
    </template>
    <template #title>
      <span :id="`${id}-card-title`" class="text-cyan-dark"> {{ title }}</span>
    </template>
    <v-card-item prepend-icon="mdi" class="mt-4">
      <template #default>
        <span
          :id="`${id}-card-subtitle`"
          class="text-none font-weight-bold text-black opacity-100"
          >{{ subtitle }}</span
        >
      </template>
    </v-card-item>
    <v-card-item :id="`${id}-card-text`" prepend-icon="mdi">{{ text }}</v-card-item>
    <v-card-item :id="`${id}-card-actions`" class="mt-auto" prepend-icon="mdi">
      <slot name="actions"></slot>
    </v-card-item>
  </v-card>
</template>

<script setup lang="ts">
  defineProps<{ id: string; icon: string; title: string; subtitle: string; text?: string }>()
</script>

<style scoped></style>
